// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.MapViewHistory {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    margin-right: 0.75em;
}

/* Look of the app menu button */
div.MapViewHistory > button {
    box-sizing: border-box;
    height: 2em;
    width: 2em;
    padding: 0;
    margin-right: 0.4em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--panel-text-color);
    border: 2px solid var(--panel-text-color);
    background-color: var(--panel-bg-color);
    cursor: pointer;
    transition: color 0.25s, border-color 0.25s, background-color 0.25s;
}

div.MapViewHistory > button:last-child {
    margin-right: 0;
}

div.MapViewHistory > button:hover:not(:disabled) {
    color: white;
    border-color: white;
}

div.MapViewHistory > button:disabled {
    opacity: 0.35;
    cursor: default;
}

/* Center the icon glyph exactly within the button */
div.MapViewHistory > button > span.icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 1em;
}

div.MapViewHistory > button > span.icon:before {
    display: block;
    width: 1em;
    height: 1em;
    line-height: 1;
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./js/style/MapViewHistory.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA,gCAAgC;AAChC;IACI,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,UAAU;IACV,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,yCAAyC;IACzC,uCAAuC;IACvC,eAAe;IACf,mEAAmE;AACvE;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,oDAAoD;AACpD;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,UAAU;IACV,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB","sourcesContent":["div.MapViewHistory {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    margin-right: 0.75em;\n}\n\n/* Look of the app menu button */\ndiv.MapViewHistory > button {\n    box-sizing: border-box;\n    height: 2em;\n    width: 2em;\n    padding: 0;\n    margin-right: 0.4em;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--panel-text-color);\n    border: 2px solid var(--panel-text-color);\n    background-color: var(--panel-bg-color);\n    cursor: pointer;\n    transition: color 0.25s, border-color 0.25s, background-color 0.25s;\n}\n\ndiv.MapViewHistory > button:last-child {\n    margin-right: 0;\n}\n\ndiv.MapViewHistory > button:hover:not(:disabled) {\n    color: white;\n    border-color: white;\n}\n\ndiv.MapViewHistory > button:disabled {\n    opacity: 0.35;\n    cursor: default;\n}\n\n/* Center the icon glyph exactly within the button */\ndiv.MapViewHistory > button > span.icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    font-size: 1em;\n}\n\ndiv.MapViewHistory > button > span.icon:before {\n    display: block;\n    width: 1em;\n    height: 1em;\n    line-height: 1;\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
